"use client";

import { useCookieConsent } from "@/hooks/useCookieConsent";
import { useTranslations } from "next-intl";

export function CookieSettingsButton() {
  const { reset } = useCookieConsent();
  const t = useTranslations("footer.bottomLinks");

  return (
    <button
      type="button"
      onClick={reset}
      className="text-base hover:underline hover:text-white/90 transition-colors"
    >
      {t("cookieSettings")}
    </button>
  );
}
